import { api } from '@sentinel/web-core';
import type {
  Bookmark,
  BookmarkCreate,
  Replay,
  Tracker,
  TrackerCreate,
  TrackerCredentials,
  TrackerUpdate,
  TrackSubjectType,
  TrackSummary,
} from '@sentinel/shared';

const base = (missionId: string) => `/missions/${missionId}`;

function windowQuery(window: { from?: string; to?: string }): string {
  const params = new URLSearchParams();
  if (window.from !== undefined) params.set('from', window.from);
  if (window.to !== undefined) params.set('to', window.to);
  const query = params.toString();
  return query === '' ? '' : `?${query}`;
}

/** Tracce e Replay (ADR 0024): trackers, replay with bookmarks, traces and their GPX. */
export const trackingEndpoints = {
  trackers: (missionId: string) => api<{ items: Tracker[] }>(`${base(missionId)}/trackers`),
  createTracker: (missionId: string, body: TrackerCreate) =>
    api<TrackerCredentials>(`${base(missionId)}/trackers`, { method: 'POST', body }),
  updateTracker: (missionId: string, deviceId: string, body: TrackerUpdate) =>
    api<Tracker>(`${base(missionId)}/trackers/${deviceId}`, { method: 'PATCH', body }),
  renewCredentials: (missionId: string, deviceId: string) =>
    api<TrackerCredentials>(`${base(missionId)}/trackers/${deviceId}/credentials`, {
      method: 'POST',
    }),
  removeTracker: (missionId: string, deviceId: string) =>
    api<undefined>(`${base(missionId)}/trackers/${deviceId}`, { method: 'DELETE' }),
  replay: (missionId: string, window: { from?: string; to?: string }) =>
    api<Replay>(`${base(missionId)}/replay${windowQuery(window)}`),
  createBookmark: (missionId: string, body: BookmarkCreate) =>
    api<Bookmark>(`${base(missionId)}/replay/bookmarks`, { method: 'POST', body }),
  removeBookmark: (missionId: string, bookmarkId: string) =>
    api<undefined>(`${base(missionId)}/replay/bookmarks/${bookmarkId}`, { method: 'DELETE' }),
  tracks: (missionId: string) => api<{ items: TrackSummary[] }>(`${base(missionId)}/tracks`),
  gpx: (missionId: string, subject: { type: TrackSubjectType; id: string }) =>
    api<Blob>(`${base(missionId)}/tracks/${subject.type}/${subject.id}/gpx`, { as: 'blob' }),
};
